import { useMemo } from 'react'
import { useEventGnbDateNew } from '../../../../modules/apis/sanity'
import { useCurrentUser } from '../../../../modules/context/UserContext'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import urls from '../../../../modules/urls'

export const ICONS = {
  student: 'https://d38emex6h5e12i.cloudfront.net/cms-video/1750311840433_product_logo-stuent.webp',
  aiTutor: 'https://d38emex6h5e12i.cloudfront.net/2024-image/1733818688631_product_logo-AITutor.webp',
  business: 'https://d38emex6h5e12i.cloudfront.net/2024-image/1733818697190_product_logo-business.webp',
  teens: 'https://d38emex6h5e12i.cloudfront.net/2024-image/1733818705044_product_logo-teens.webp',
} as const

export const LANDING_NAV = {
  HEIGHT: 'h-[58px]',
  Z_INDEX: 'z-[100]',
} as const

export const SUB_NAV = {
  HEIGHT: 'h-[58px]',
  MAX_WIDTH: 'max-w-[1180px]',
} as const

export type SubNavMenu = 'lesson' | 'aiTutor'

export const checkIsSelected = (router, link: string) => {
  const path = router.asPath.split('?')[0]
  return path === link || path.endsWith(link)
}

const useLandingNav = () => {
  const router = useAppRouter()
  const isMobile = useIsMobile()
  const { currentUser } = useCurrentUser()
  const { data: promotionData } = useEventGnbDateNew()
  const { lang } = router.query
  const isLogin = !!currentUser
  const conditions = ['landing/home', 'auth', 'blog', 'refferal']
  const isSubNavVisible = !isMobile && !conditions.some((path) => router.pathname.includes(path))
  const type = router.query.type as string
  const isAITutorMenu = router.pathname.includes('pricing') && type === 'ai-tutor'

  const navigateToSignUp = () => {
    router.push(urls.student.auth.new)
  }

  const navigateToSignIn = () => {
    router.push(urls.student.auth.signIn)
  }

  const navigateToPortalHome = () => {
    router.push(urls.student.newPortal.home)
  }

  const navigateToLesson = () => {
    router.push(urls.student.adv.index('1on1'))
  }

  const navigateToAITutor = () => {
    router.push(urls.student.adv.index('aitutor'))
  }

  const handleStartClick = () => {
    if (isLogin) {
      navigateToPortalHome()
    } else {
      navigateToSignUp()
    }
  }

  const navigateToPricing = () => {
    if (isLogin) {
      router.push(`${urls.student.newPortal.pricing.index}?type=combined`)
    } else {
      router.push(urls.student.landing.pricing)
    }
  }

  const promotions = useMemo(() => {
    return (
      promotionData?.items.map((item) => ({
        isPublic: item.isPublic,
        label: item.label,
        link: item.link,
        dDay: item.d_day,
      })) || []
    )
  }, [promotionData])

  return {
    lang,
    currentUser,
    isLogin,
    isSubNavVisible,
    isAITutorMenu,
    promotions,
    navigateToSignUp,
    navigateToSignIn,
    navigateToPortalHome,
    navigateToPricing,
    navigateToLesson,
    navigateToAITutor,
    handleStartClick,
  }
}

export default useLandingNav

const PRODUCT_CATEGORIES = {
  PLUS: '성인',
  BUSINESS: 'B2B',
  TEENS: '학생',
}

const LENDING_NAV = {
  main: {
    products: {
      key: 'products',
      icon: ICONS.student,
      title: '제품소개',
      items: [
        {
          category: PRODUCT_CATEGORIES.PLUS,
          items: [
            {
              key: 'lesson',
              icon: ICONS.student,
              title: '링글 1:1 화상영어',
              description: '명문대 원어민과 실전 영어 연습',
              // onClick: () => router.push(urls.student.adv.index(links.framer.advPath['1on1'].index)),
            },
            {
              key: 'aiTutor',
              icon: ICONS.aiTutor,
              title: '링글 AI 튜터',
              description: '명문대 원어민과 실전 영어 연습',
              // onClick: () => router.push(urls.student.adv.index(links.framer.advPath.aiTutor.index)),
            },
          ],
        },
        {
          category: 'business',
          items: [
            {
              key: 'business',
              icon: ICONS.business,
              title: '링글 기업 영어 솔루션',
              description: '채용부터 교육, 관리까지',
              // onClick: () => router.push(urls.b2b.index),
            },
          ],
        },
        {
          category: 'teens',
          items: [
            {
              key: 'teens',
              icon: ICONS.teens,
              title: '링글 학생 영어 솔루션',
              description: '채용부터 교육, 관리까지',
              isExternal: true,
              // onClick: () => window.open(links.teens.index, '_blank'),
            },
          ],
        },
      ],
    },
    userTestimonials: {
      key: 'userTestimonials',
      icon: ICONS.student,
      title: '링글 학생 영어 솔루션',
      link: '',
    },
    business: {
      key: 'business',
      icon: ICONS.business,
      title: '링글 기업 영어 솔루션',
      link: '',
    },
  },
  // product: {
  //   lesson: {
  //     key: 'lesson',
  //     icon: ICONS.student,
  //     title: '링글 1:1 화상영어',
  //   },
  //   aiTutor: {
  //     key: 'aiTutor',
  //     icon: ICONS.aiTutor,
  //     title: '링글 AI 튜터',
  //   },
  // },
}
